export default {
  SUPERVISOR: 'SUPERVISOR',
  COLLABORATOR: 'COLLABORATOR',
}
